<template>
  <transition name="slide">
    <div
      class="notification-container"
      v-bind:class="currentStatus"
      v-if="message"
    >
      <div class="w100">
        <img :src="statusImage" :alt="message" />
        <span v-safe-html="message" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "NotificationToast",
  computed: {
    currentStatus() {
      /**
       * Generar clase para status
       * Default "info"
       */
      const valid = ["info", "success", "alert"];
      return valid.indexOf(this.type) !== -1 ? this.type : "info";
    },
    statusImage() {
      /**
       * Generar imagen de status
       */
      const images = {
        info: require(`@/assets/img/1x/info-white.svg`),
        success: require(`@/assets/img/1x/success-white.svg`),
        alert: require(`@/assets/img/1x/alert-white.svg`)
      };

      return images[this.currentStatus];
    },
    ...mapState({
      message: state => state.notificationToast.message,
      type: state => state.notificationToast.type
    })
  }
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: left;
  color: white;
  font-family: BentonSansBBVA-Light, Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-size: 16px;
  line-height: 1.3em;
}

.notification-container .w100 {
  padding: 16px 17px;
  line-height: 26px;
  text-align: center;
}

/* Icon */
img {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-bottom: 12px;
}

/* Text */
span {
  vertical-align: middle;
  margin-top: 6px;
}

/* Statuses*/
.notification-container.info {
  background-color: #1464a5;
}

.notification-container.success {
  background-color: #277a3e;
}

.notification-container.alert {
  background-color: #b92a45;
}

/* Transition */
.slide-enter-active,
.slide-leave-active {
  transform: translateY(0);
  transition: all 0.5s;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
}

/** Mobile */
@media screen and (max-width: 600px) {
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }

  .notification-container .w100 {
    padding: 8px 17px;
  }
}
</style>
